import { combineReducers } from 'redux';
import callback from './callbackReducer';
import channels from './channelsReducer';
import emailUs from './emailUsReducer';
import postal from './postalReducer';
export default combineReducers({
    callback,
    channels,
    emailUs,
    postal
});
